import React from "react";

export interface VisitBulkSelectCheckboxProps {
  ariaLabel: string;
  checked: boolean;
  indeterminate: boolean;
  onToggle: () => void;
  className?: string;
}

/** Controlled checkbox with indeterminate state for bulk row / group selection. */
export const VisitBulkSelectCheckbox: React.FC<VisitBulkSelectCheckboxProps> = ({
  ariaLabel,
  checked,
  indeterminate,
  onToggle,
  className = "",
}) => {
  const inputRef = React.useCallback(
    (el: HTMLInputElement | null) => {
      if (el) el.indeterminate = indeterminate;
    },
    [indeterminate]
  );

  return (
    <input
      ref={inputRef}
      type="checkbox"
      aria-label={ariaLabel}
      checked={checked}
      onChange={onToggle}
      className={`h-4 w-4 shrink-0 cursor-pointer rounded border-neutral-300 accent-primary focus-visible:shadow-focus-inset ${className}`}
    />
  );
};
